module.exports = __webpack_public_path__ + "static/media/giphy.05ff97af.gif";